/* eslint-disable  @typescript-eslint/no-explicit-any */

import { Alert, Card } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'components/base/Button';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import React from 'react';

interface Transcript {
    request_id: string;
    response: {
        answer: string;
        question: number;
    }[];
}


const AnalysisView = ({
    analysis,
    className, onRefresh,
}: { analysis: string, className?: string, onRefresh?: () => void }) => {

    const { t } = useTranslation();

    if (analysis === '') return (<>
        <Alert style={{ backgroundColor: '#d1e7dd' }}>
            <Alert.Heading className='text-body'>{t("AnalysisView.alert.title")}</Alert.Heading>
            <p className='text-body'>{t("AnalysisView.alert.message")}</p>
            <Button type="submit" variant="primary" onClick={onRefresh} className="px-6 ms-auto"> {t("AnalysisView.alert.refresh")} </Button>
        </Alert>
    </>)

    const data: Transcript = JSON.parse(analysis);

    const formatText = (text: string) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };


    return (
        <Card className={classNames(className, 'w-100')}>
            <Card.Body>
                <Card.Title> <h3>{t("AnalysisView.title")}</h3> </Card.Title>
                <Accordion >
                    {data.response.map((item, index) => (
                        <Accordion.Item key={index} eventKey={"" + index} className="border-top border-300 p-2">
                            <Accordion.Header className="px-5 px-lg-6 bg-soft" >{item.question}</Accordion.Header>
                            <Accordion.Body className="d-flex align-items-center mb-5">

                                <div className="px-5 px-lg-6 pt-1 bg-white">
                                    <div className="d-flex align-items-center mb-0">
                                        <p>
                                            {formatText(item.answer)}
                                        </p>
                                    </div>
                                </div>

                            </Accordion.Body>
                        </Accordion.Item>
                    ))}

                </Accordion>
            </Card.Body>
        </Card>

    );
};

export default AnalysisView;
